import React, { useState, useEffect } from 'react';
import { FaBook } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './cursos.css';
import ModalCursos from './modalcursos';
import Formulario from '../formulario/formulario';
import OwlFAB from '../pet/pet';
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { obtenerTodosProgramas } from '../../../funtions';
import carga from '../../carga/carga';

function Cursos({ openFormulario = false, onSetOpenFormulario = () => {} }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSocialIndex, setCurrentSocialIndex] = useState(0);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Cargar programas básicos desde Firestore
  useEffect(() => {
    const loadPrograms = async () => {
      try {
        carga.mostrarCarga();
        const programas = await obtenerTodosProgramas();
        // Excluir los programas cuya categoría sea "Programa","Capacitación Empresarial"
        const basicProgramas = programas
          .filter((p) => p.categoria !== 'Programa' && p.categoria !== 'Capacitación Empresarial'&& p.categoria !== 'Convalidación'&& p.categoria !== 'Home School')
          .map(p => ({
            id: p.id,
            nombre: p.nombre,
            descripcion: p.descripcion,
            descriptionp: p.descriptionp,
            cardPrincipal: p.cardPrincipal,
            categoria: p.categoria,
          }));
        setCourses(basicProgramas);
      } catch (error) {
        console.error('Error cargando programas:', error);
      } finally {
        setLoading(false);
        carga.ocultarCarga();
      }
    };

    loadPrograms();
  }, []);

  const openModal = (courseId) => {
    setSelectedCourseId(courseId);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedCourseId(null);
  };

  // Redes sociales para el botón flotante
  const socials = [
    { icon: FaFacebookF, color: '#1877f2', link: 'https://www.facebook.com/EnsenarteOnline', label: 'Facebook' },
    { icon: FaInstagram, color: '#dd2a7b', link: 'https://www.instagram.com/ensenarte.online', label: 'Instagram' },
    { icon: FaTiktok, color: '#000', link: 'https://www.tiktok.com/@ensenarte.online', label: 'TikTok' },
    { icon: FaWhatsapp, color: '#25d366', link: 'https://wa.me/573007714104', label: 'WhatsApp' },
  ];

  // Bucle de redes sociales en el botón flotante
  useEffect(() => {
    if (isMenuOpen) return;

    const interval = setInterval(() => {
      setCurrentSocialIndex((prevIndex) => (prevIndex + 1) % socials.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [isMenuOpen, socials.length]);

  return (
    <section id="cursos" className="cursos-section section-animated">
      <div className="cursos-container">
        <div className="cursos-header">
          <h2 className="cursos-title">Nuestros Programas</h2>
          <button className="cursos-back-button" onClick={() => navigate('/landingpage')}>← Volver</button>
        </div>
        <p className="cursos-subtitle-main">Descubre nuestros programas educativos diseñados para tu éxito profesional.</p>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-color)' }}>
            Cargando programas...
          </div>
        ) : (
          <div className="cursos-grid">
            {courses.map((course, index) => {
              const hasImage = Boolean(course.cardPrincipal);
              return (
                <article
                  key={course.id || index}
                  className={`curso-card ${hasImage ? 'has-image' : 'no-image'}`}
                  onClick={() => openModal(course.id)}
                  style={hasImage ? { backgroundImage: `url(${course.cardPrincipal})` } : undefined}
                >
                  {hasImage ? (
                    <div className="curso-card-overlay">
                      <div className="curso-card-content">
                        <div className="curso-icon">
                          <FaBook size={32} />
                        </div>
                        <h3>{course.nombre}</h3>
                        <p className="curso-description">{course.descriptionp || course.descripcion}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="curso-card-content no-image">
                      <div className="curso-icon">
                        <FaBook size={32} />
                      </div>
                      <h3>{course.nombre}</h3>
                      <p className="curso-description">{course.descriptionp || course.descripcion}</p>
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        )}
      </div>

      {/* Modal separado */}
      <ModalCursos 
        isOpen={modalOpen} 
        courseId={selectedCourseId} 
        onClose={closeModal} 
      />

      {/* Formulario */}
      <Formulario openForm={openFormulario} onClose={() => onSetOpenFormulario(false)} />

      {/* Botón flotante de redes sociales */}
      <div className="floating-social-button">
        <button
          className="floating-social-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{
            backgroundColor: socials[currentSocialIndex].color,
          }}
        >
          {!isMenuOpen ? (
            React.createElement(socials[currentSocialIndex].icon, { size: 24 })
          ) : (
            <span>✕</span>
          )}
        </button>

        {/* Menú de redes sociales */}
        {isMenuOpen && (
          <div className="floating-social-menu">
            {socials.map((social, index) => {
              const IconComponent = social.icon;
              return (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noreferrer"
                  className="floating-social-link"
                  style={{ backgroundColor: social.color }}
                  title={social.label}
                >
                  <IconComponent size={20} />
                </a>
              );
            })}
          </div>
        )}
      </div>

      <OwlFAB />
    </section>
  );
}

export default Cursos;